<template>
  <b-row>
    <b-col cols="12" sm="12">
      <b-card class="mx-auto no-layered box" tile>
        <InputBuscar :filter="filter" @input="filter = $event" />
        <b-form @submit.stop.prevent="convertirFechas">
          <div class="row">
            <div class="col-xs-6 col-sm-6 col-md-4 col-lg-5">
              <label for="labelFiltrado" class="d-flex">{{ $t("vBitacora.filtrado") }}:</label>
              <b-form-select id="labelFiltrado" v-model="selected2" :options="translateOptions" value-field="value" text-field="text"
                required @input="inputSelect2">
              </b-form-select>
            </div>
            <div class="col-xs-6 col-sm-6 col-md-5 col-lg-5 margin-top-div-rfecha">
              <label for="rangoFechas"  class="d-flex">{{ $t("Gral.rangoFechas") }}:</label>
              <flat-pickr v-model="rangoFechas" :config="configDateRange" id="rangoFechas"
                class="form-control" :placeholder="$t('Gral.seleccionarFecha')" name="date" />
            </div>
            <div class="col-xs-6 col-sm-12 col-md-3 col-lg-2 d-flex align-items-end margin-top-div-consultar">
              <b-btn class="d-flex align-items-center justify-content-center w-100" style="color: white" variant="info"
                text type="submit" color="blue" :disabled="!rangoFechas">
                <feather type="search" class="feather-sm mr-2"></feather>
                {{ $t("vBitacora.consultar") }}
              </b-btn>
            </div>
          </div>
        </b-form>
        <div class="row mt-2">
          <div class="col-md-12">
            <BaseTable tableClass="mb3 logacciones" :items="acciones" :fields="translatedHeaders"
              :currentPage="currentPage" :perPage="perPage" :filter="filter" @filtered="onFiltered"
              :total-rows="totalRows" style="text-align: center">
            </BaseTable>
          </div>
        </div>
      </b-card>
    </b-col>
  </b-row>
</template>

<script>
import AccionesDataService from "../../../services/AccionesDataService";
import { verificarAcceso } from '../../../utils/Session';
import Jwt from "../../../services/Jwt";
import Crypto from "../../../services/Crypto"

import { mapState } from "vuex";
import { validationMixin } from "vuelidate";
import flatPickr from "vue-flatpickr-component";

import "flatpickr/dist/flatpickr.css";
import "flatpickr/dist/themes/material_blue.css";
import { Spanish } from "flatpickr/dist/l10n/es.js";
import flatpickr2 from "flatpickr";

import BaseTable from "../../components/BaseTable.vue";
import InputBuscar from "../../components/InputBuscar.vue";

export default {
  name: "acciones",
  mixins: [validationMixin],
  components: {
    flatPickr,
    BaseTable,
    InputBuscar
  },

  data() {
    return {
      busy: true,
      fechaInicial: flatpickr2.formatDate(new Date(), "Y-m-d"),
      fechaFinal: flatpickr2.formatDate(new Date(), "Y-m-d"),
      rangoFechas: null,
      selected2: "completo",
      filtro: null,
      fecha: {
        inicial: null,
        final: null,
      },
      configDate: {
        wrap: true,
        altFormat: "M j, Y",
        altInput: true,
        dateFormat: "Y-m-d",
        maxDate: new Date(),
      },
      configDateFin: {
        wrap: true,
        altFormat: "M j, Y",
        altInput: true,
        dateFormat: "Y-m-d",
        minDate: this.fechaFinalPicker,
        maxDate: new Date(),
      },
      configDateRange: {
        wrap: true,
        altFormat: "M j, Y",
        altInput: true,
        dateFormat: "Y-m-d",
        minDate: new Date('Nov 1, 2021'), //Tomando en cuenta que antes de 2021 no existía el sistema, la fecha limite de inicio  se configura al 1-nov-2021
        maxDate: new Date(),
        mode: "range",
        locale: Spanish,
      },
      acciones: [],
      accion: {
        id: 0,
        usuario: "",
        rol: "",
        grupo: "",
        accion: "",
        fechaCreacion: ""
      },
      nameState: null,
      headers: [
        {
          key: "usuario", //matricula de usuario
          label: "usuario",
          sortable: true,
        }, {
          key: "rol", //nivel de usuario
          label: "rol",
          sortable: true,
        }, {
          key: "grupo", // grupo (no aplica a master)
          label: "grupo",
          sortable: true,
        }, {
          key: 'accion',
          label: 'registros',
          sortable: true,
        }, {
          key: 'fechaCreacionOrden',
          label: 'fechaRegistro',
          sortable: true,
          formatter: (value, key, item) => item.fechaCreacion
        },
      ],
      totalRows: 50,
      perPage: 50,
      currentPage: 1,
      filter: null,
      banderaSelect: true,
      options: [
        { value: "completo", text: 'filtroCompleto' },
        { value: "accion", text: 'filtroAcciones' },
        { value: "configuracion", text: 'filtroConfiguracion' },
      ],
      key: ""
    };
  },

  beforeCreate() {
    verificarAcceso();

    if (!sessionStorage.getItem('rol') || sessionStorage.idRol === process.env.VUE_APP_ID_USUARIO_FINAL || sessionStorage.idRol === process.env.VUE_APP_ID_ADMINISTRADOR) {
      this.$router.push({
        path: "/monitoreo"
      });
      const Toast = this.$swal.mixin({
        toast: true,
        position: 'top-end',
        showConfirmButton: false,
        timer: 4000,
        timerProgressBar: true,
        didOpen: (toast) => {
          toast.addEventListener('mouseenter', this.$swal.stopTimer)
          toast.addEventListener('mouseleave', this.$swal.resumeTimer)
        }
      });

      Toast.fire({
        icon: 'error',
        title: this.$t('vDispositivos.noPermisos')
      });
    }
  },

  mounted() {
    this.busy = false;
    this.key = sessionStorage.getItem('key')
    this.$nextTick(() => {
      this.obtenerTodos();
    });
  },

  computed: {
    ...mapState(['locale']),
    translatedHeaders() {
      // Mapea y traduce las etiquetas del arreglo headers.
      return this.headers.map(header => {
        if (typeof header === 'object' && header.label) {
          return {
            ...header,
            label: this.$t(`tableHeaders.${header.label}`)
          };
        } else {
          return header;
        }
      });
    },
    translateOptions() {
      return this.options.map(option => {
        if (typeof option === 'object' && option.text) {
          return {
            ...option,
            text: this.$t(`vBitacora.${option.text}`)
          };
        }
      })
    },
    fechaInicialPicker() {
      return this.fechaInicial;
    },
    fechaFinalPicker() {
      return this.fechaFinal;
    },
  },
  methods: {
    checkFormValidity() {
      const valid = this.$refs.form.checkValidity()
      this.nameState = valid
      return valid
    },
    obtenerTodos() {
      AccionesDataService.getAll().then(async(response) => {
        const decoded = await Crypto.desencriptar(response.data, this.key);

        this.acciones = decoded.map(this.getDisplayAcciones);

        if (this.acciones.length >= 300) { //limita la carga de registros a solo 300
          this.totalRows = 300;
        } else {
          this.totalRows = this.acciones.length;
        }
        if (this.acciones.length === 0) {
          throw new Error("Status: " + 404);
        }
      }).catch((e) => {
        this.busy = false;
        let textoExcepcion = this.$t('vBitacora.msgErrorCargar');
        if (e === "vacio") {
          textoExcepcion = this.$t('vBitacora.msgBitacoraVacia');
        }
        const Toast = this.$swal.mixin({
          toast: true,
          position: "top-end",
          showConfirmButton: false,
          timer: 3000,
          timerProgressBar: true,
          didOpen: (toast) => {
            toast.addEventListener("mouseenter", this.$swal.stopTimer);
            toast.addEventListener("mouseleave", this.$swal.resumeTimer);
          },
        });
        Toast.fire({
          icon: "error",
          title: textoExcepcion,
        });
      });
    },
    getDisplayAcciones(accion) {
      this.busy = false;
      let options = {
        weekday: "long",
        year: "numeric",
        month: "long",
        day: "numeric",
        hour: "numeric",
        minute: "numeric",
        second: "numeric",
        //hour12: "true",
      };
      let area = "No aplica";
      let matri = "Desconocido";
      let role = "Desconocido";

      if (accion.usuario) {
        matri = accion.usuario.matricula;
        role = accion.usuario.rol.role;
        if (accion.usuario.area)
          area = accion.usuario.area.nombre;
      }

      const fechaDate = new Date(accion.fechaCreacion);

      return {
        id: accion.id,
        usuario: matri,
        rol: role,
        grupo: area,
        accion: accion.accion,
        fechaCreacion: new Date(accion.fechaCreacion).toLocaleDateString('es-ES', options),
        fechaCreacionOrden: fechaDate,
      };
    },
    inputSelect2() {
      this.$emit("input", (this.filtro == this.selected2));
    },
    convertirFechas() {
      this.busy = true;
      //Separar rango de fechas
      const myArr = this.rangoFechas.split(" ");
      this.fecha.inicial = myArr[0];
      if (myArr.length > 2) {
        this.fecha.final = myArr[2];
      } else {
        this.fecha.final = this.fecha.inicial;
      }

      sessionStorage.setItem("fechaIniLog", this.fecha.inicial);
      sessionStorage.setItem("fechaFinLog", this.fecha.final);
      sessionStorage.setItem("filtro", this.filtro);

      const data = {
        fechaInicial: this.fecha.inicial,
        fechaFinal: this.fecha.final
      }

      if (this.filtro == null || this.filtro === "completo") {
        this.obtenerLogPorFechas(data);
      } else {
        this.obtenerLogFiltrado();
      }
    },
    obtenerLogPorFechas(data) {
      AccionesDataService.getAllByDate(data, this.key).then(async(response) => {
        const decoded = await Crypto.desencriptar(response.data, this.key);
        this.acciones = decoded.map(this.getDisplayAcciones);
        this.totalRows = this.acciones.length;
        if (this.acciones.length === 0) {
          throw new Error("Status: " + 404);
        } else {
          const Toast = this.$swal.mixin({
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
            timerProgressBar: true,
            didOpen: (toast) => {
              toast.addEventListener("mouseenter", this.$swal.stopTimer);
              toast.addEventListener("mouseleave", this.$swal.resumeTimer);
            },
          });
          Toast.fire({
            icon: "success",
            title: this.$t('vBitacora.msgCargarHistorial'),
          });
        }
      }).catch((e) => {
        this.busy = false;
        let textoExcepcion = this.$t('vBitacora.msgErrorCargar');
        if (e === "vacio") {
          textoExcepcion = this.$t('vBitacora.msgSinRegistros');
        }
        const Toast = this.$swal.mixin({
          toast: true,
          position: "top-end",
          showConfirmButton: false,
          timer: 3000,
          timerProgressBar: true,
          didOpen: (toast) => {
            toast.addEventListener("mouseenter", this.$swal.stopTimer);
            toast.addEventListener("mouseleave", this.$swal.resumeTimer);
          },
        });
        Toast.fire({
          icon: "error",
          title: textoExcepcion,
        });
      });
    },
    obtenerLogFiltrado() {
      AccionesDataService.getAllByFiltro().then((response) => {
        let decoded = Jwt.jwtDecode(response.data);
        this.acciones = decoded.map(this.getDisplayAcciones);
        this.totalRows = this.acciones.length;
        if (this.acciones.length === 0) {
          throw new Error("Status: " + 404);
        } else {
          const Toast = this.$swal.mixin({
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
            timerProgressBar: true,
            didOpen: (toast) => {
              toast.addEventListener("mouseenter", this.$swal.stopTimer);
              toast.addEventListener("mouseleave", this.$swal.resumeTimer);
            },
          });
          Toast.fire({
            icon: "success",
            title: this.$t('vBitacora.msgCargarHistorial'),
          });
        }
      }).catch((e) => {
        this.busy = false;
        let textoExcepcion = this.$t('vBitacora.msgErrorCargar');
        if (e === "vacio") {
          textoExcepcion = this.$t('vBitacora.msgSinRegistros');
        }
        const Toast = this.$swal.mixin({
          toast: true,
          position: "top-end",
          showConfirmButton: false,
          timer: 3000,
          timerProgressBar: true,
          didOpen: (toast) => {
            toast.addEventListener("mouseenter", this.$swal.stopTimer);
            toast.addEventListener("mouseleave", this.$swal.resumeTimer);
          },
        });
        Toast.fire({
          icon: "error",
          title: textoExcepcion,
        });
      });
    },
    onFiltered(filteredItems) {
      this.totalRows = filteredItems
      this.currentPage = 1
    },
  },
};
</script>

<style>
.styleTitleB {
  font-size: 25px;
  font-weight: bold;
  color: rgb(12, 33, 92);
  margin-top: 0px;
}

#mySpinner {
  display: none;
}

#labelSpinner {
  font-size: 30px;
  font-weight: 700;
}

.myMarginBit {
  margin-left: 1rem;
  margin-top: 20px;
}

@media (max-width: 599px) {
  .margin-top-div-limpiar {
    margin-top: -12px;
  }
}

@media (min-width: 600px) {
  .margin-top-div-limpiar {
    margin-top: 0px;
  }
}

@media (min-width: 700px) and (max-width: 959px) {
  .margin-top-div-consultar {
    margin-top: -12px;
  }
}

@media (max-width: 699px) {
  .margin-top-div-consultar {
    margin-top: -12px;
  }
}

@media (max-width: 575px) {
  .margin-top-div-rfecha {
    margin-top: -12px;
  }
}

@media (max-width: 991.98px) and (max-height: 950px) {
  .myMarginBit {
    margin-left: 0px;
    margin-top: 1rem;
  }

  #labelSpinner {
    font-size: 20px;
    font-weight: 500;
  }

  /* Force table to not be like tables anymore */
  .logacciones table,
  .logacciones thead,
  .logacciones tbody,
  .logacciones th,
  .logacciones td,
  .logacciones tr {
    display: block;
  }

  /* Hide table headers (but not display: none;, for accessibility) */
  .logacciones thead tr {
    position: absolute;
    top: -9999px;
    left: -9999px;
  }

  .logacciones tr {
    border: 1px solid #ccc;
  }

  .logacciones td {
    /* Behave  like a "row" */
    border: none;
    border-bottom: 1px solid #eee;
    position: relative;
    padding-left: 5%;
    text-align: left;
  }

  .logacciones td:after {
    /* Now like a table header */
    position: relative;
    /* Top/left values mimic padding */
    top: 6px;
    left: 6px;
    width: 70%;
    padding-right: 10px;
    white-space: nowrap;
  }

  /*
	Label the data
	*/
  .logacciones td:nth-of-type(1):before {
    content: "Usuario: ";
  }

  .logacciones td:nth-of-type(2):before {
    content: "Rol: ";
  }

  .logacciones td:nth-of-type(3):before {
    content: "Grupo: ";
  }

  .logacciones td:nth-of-type(4):before {
    content: "Acción: ";
  }

  .logacciones td:nth-of-type(5):before {
    content: "Fecha de registro: ";
  }
}
</style>
